/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedServiceName
 */
export interface PatchedServiceName {
    /**
     * 
     * @type {number}
     * @memberof PatchedServiceName
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedServiceName
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedServiceName
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedServiceName
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PatchedServiceName
     */
    readonly leaksCount?: string;
}

/**
 * Check if a given object implements the PatchedServiceName interface.
 */
export function instanceOfPatchedServiceName(value: object): value is PatchedServiceName {
    return true;
}

export function PatchedServiceNameFromJSON(json: any): PatchedServiceName {
    return PatchedServiceNameFromJSONTyped(json, false);
}

export function PatchedServiceNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedServiceName {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'leaksCount': json['leaks_count'] == null ? undefined : json['leaks_count'],
    };
}

  export function PatchedServiceNameToJSON(json: any): PatchedServiceName {
      return PatchedServiceNameToJSONTyped(json, false);
  }

  export function PatchedServiceNameToJSONTyped(value?: Omit<PatchedServiceName, 'id'|'created_at'|'updated_at'|'leaks_count'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

